import React from 'react';

const Exit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.999"
    height="20"
    viewBox="0 0 19.999 20"
  >
    <path
      d="M14.6,15.313v1.563A3.128,3.128,0,0,1,11.477,20H3.625A3.128,3.128,0,0,1,.5,16.875V3.125A3.128,3.128,0,0,1,3.625,0h7.852A3.128,3.128,0,0,1,14.6,3.125V4.687a.781.781,0,1,1-1.562,0V3.125a1.564,1.564,0,0,0-1.563-1.562H3.625A1.564,1.564,0,0,0,2.063,3.125v13.75a1.564,1.564,0,0,0,1.562,1.562h7.852a1.564,1.564,0,0,0,1.563-1.562V15.313a.781.781,0,1,1,1.562,0Zm5.326-6.655L18.179,6.909a.781.781,0,0,0-1.1,1.1l1.244,1.245H8.938a.781.781,0,1,0,0,1.563h9.38l-1.244,1.245a.781.781,0,1,0,1.1,1.1l1.749-1.749A1.955,1.955,0,0,0,19.928,8.658Zm0,0"
      transform="translate(-0.5)"
    />
  </svg>
);

export default Exit;
